import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getForgotPasswordModalOpen } from '../selectors/InteractionSelector';
import ForgotPasswordModal from '../components/ForgotPasswordModal';
import { resetPassword } from '../actions/ProfileActions';
import { toggleForgotPasswordModalOpen } from '../actions/AppActions';
import { getEmailAddressFromCurrentUserProfile } from '../selectors/ProfileSelector';
import { trackScreen } from '../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
class ForgotPasswordModalContainer extends Component {
  constructor(props) {
    super(props);
    this.onResetPassword = this.onResetPassword.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (this.props.forgotPasswordModalOpen && !prevProps.forgotPasswordModalOpen) {
      trackScreen('forgot-password-modal');
    }
  }
  onResetPassword() {
    this.props.resetPassword(this.props.emailAddressFromProfile);
    this.props.toggleForgotPasswordModalOpen();
  }
  onCloseModal() {
    this.props.toggleForgotPasswordModalOpen();
  }
  render() {
    const {
      emailAddressFromProfile,
      forgotPasswordModalOpen
    } = this.props;
    if (forgotPasswordModalOpen) {
      return /*#__PURE__*/_jsx(ForgotPasswordModal, {
        emailAddressFromProfile: emailAddressFromProfile,
        onCloseModal: this.onCloseModal,
        onResetPassword: this.onResetPassword
      });
    }
    return null;
  }
}
ForgotPasswordModalContainer.propTypes = {
  forgotPasswordModalOpen: PropTypes.bool.isRequired,
  emailAddressFromProfile: PropTypes.string.isRequired,
  resetPassword: PropTypes.func.isRequired,
  toggleForgotPasswordModalOpen: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    emailAddressFromProfile: getEmailAddressFromCurrentUserProfile(state),
    forgotPasswordModalOpen: getForgotPasswordModalOpen(state)
  };
};
export default connect(mapStateToProps, {
  resetPassword,
  toggleForgotPasswordModalOpen
})(ForgotPasswordModalContainer);